import React from 'react';
import './dark.css';


const Dark = () => {
  return (
    <div>
      
    </div>
  );
};

export default Dark;